export const FareEstimateFormErrorMsg = {
  name_required: 'Name is required',
  name_invalid: 'Name must contain at least 3 alphabets',
  mobile_required: 'Mobile is required',
  mobile_invalid: 'Invalid mobile number',
  requirement: 'Please select a valid option for requirement.',
  pickup: 'Pickup address is required',
  drop: 'Drop address is required',
  pickup_required: 'Enter the pickup address',
  drop_required: 'Enter the dropoff address',
} as const;

//Get icons from sprite
export const FareEstimateFormAssets = {
  drop: {
    icon: 'https://nest-platform-assets.porter.in/drop_address_e0335d60b3/drop_address_e0335d60b3.svg',
    alt: 'Drop Location',
  },
  pickup: {
    icon: 'https://nest-platform-assets.porter.in/from_input_9224516e71/from_input_9224516e71.svg',
    alt: 'Pickup Location',
  },
  call: {
    icon: 'https://nest-platform-assets.porter.in/call_Filled_753ba7fdd8/call_Filled_753ba7fdd8.svg',
    alt: 'Call',
  },
  user: {
    icon: 'https://nest-platform-assets.porter.in/name_input_f03f884446/name_input_f03f884446.svg',
    alt: 'User',
  },
  business: {
    icon: 'https://nest-platform-assets.porter.in/business_e8cb8eaab3/business_e8cb8eaab3.svg',
    alt: 'Business',
  },
  personal: {
    icon: 'https://nest-platform-assets.porter.in/personal_e2011b4ae4/personal_e2011b4ae4.svg',
    alt: 'Personal',
  },
  dropdown: {
    icon: 'https://nest-platform-assets.porter.in/drop_down_black_cfb393204a/drop_down_black_cfb393204a.svg',
    alt: 'Dropdown',
  },
  rightArrow: {
    icon: 'https://nest-platform-assets.porter.in/right_arrow_db54b8ed6d/right_arrow_db54b8ed6d.svg',
    alt: 'Right Arrow',
  },
} as const;

export const FareEstimateFormPlaceholder = {
  name: 'Enter Name',
  mobile: 'Enter Mobile',
  pickup: 'Enter Pickup Location',
  drop: 'Enter Drop Location',
} as const;

export const FareEstimateFormLabel = {
  personal: 'personal',
  business: 'business',
  estimate_button: 'Get Fare Estimate',
  estimate_button_desktop: 'Book Now!',
  requirement_title_label: 'I will be using Porter mainly for:',
  requirement_desc_label: 'Why do you want to use Porter for?',
  requirement_title_desktop_label: 'What best describes you?',
  two_wheelers_label_payload: '2 wheeler',
  trucks_label_payload: 'trucks',
  partload_label_payload: 'trucks',
  desktop_heading: 'Your Booking is a Step Away!',
} as const;

export const FareEstimateRequirementContent = {
  business: {
    title: 'My Business Needs',
    desc: 'Shipping goods like plywood, tiles, electronics, etc.',
  },
  personal: {
    title: 'My Personal Needs',
    desc: 'Shipping items like tiffins, clothes, documents, etc.',
  },
} as const;

export let form_submit_ga_event_prefix = 'Get Trip Estimate Click - ';
export let form_submit_ga_event_uae = 'Get Trip Estimate Click UAE';

export let ga_fare_estimate_form_validation =
  'Get Trip Estimate Validation Successful';
export let ga_fare_estimate_successful = 'Get Trip Estimate Successful';
export let ga_fare_estimate_successful_2w = 'Get Trip Estimate Successful - 2W';
export let ga_fare_estimate_successful_trucks =
  'Get Trip Estimate Successful - Trucks';
export let ga_fare_estimate_successful_partload =
  'Get Trip Estimate Successful - Partload';

export let service_category_trucks = 'trucks';
export let service_category_two_wheelers = '2 wheeler';
export let ga_event_2w = '2w';
export let service_category_partload = 'partload';

export let two_wheeler_source = 'home_2W';
export let trucks_wheeler_source = 'home_Trucks';
export let vehicle_trucks_source = 'trucks_fare_estimate';
export let vehicle_2w_source = 'two_wheelers_fare_estimate';

export let porter_requirement = 'What will you use Porter for?';

export const success_v2_events_uae = [
  'Get Trip Estimate Successful UAE',
  'Fare Estimate Successful V2 UAE',
];
